import { Controller } from "stimulus";

console.log("[PADDLE CONTROLLER] File loaded - paddle-checkout-controller.ts");

// Declare Paddle types for TypeScript
declare global {
  interface Window {
    Paddle: {
      Checkout: {
        open: (options: PaddleCheckoutOptions) => void;
      };
    };
  }
}

interface PaddleCheckoutOptions {
  items: Array<{
    priceId: string;
    quantity: number;
  }>;
  customer?: {
    email?: string;
    id?: string;
  };
  customData?: Record<string, any>;
}

export default class extends Controller {
  static values = {
    priceId: String,
    customerEmail: String,
    customData: Object,
  };

  declare priceIdValue: string;
  declare customerEmailValue: string;
  declare customDataValue: Record<string, any>;

  connect() {
    console.log("[PADDLE CONTROLLER] Connected to element");
    console.log("[PADDLE CONTROLLER] Price ID:", this.priceIdValue);
    console.log("[PADDLE CONTROLLER] Customer Email:", this.customerEmailValue);
    console.log("[PADDLE CONTROLLER] Custom Data:", this.customDataValue);
  }

  // Open overlay checkout for new subscription
  // Docs: https://developer.paddle.com/paddlejs/methods/paddle-checkout-open
  openCheckout(event: Event): void {
    console.log("[PADDLE CONTROLLER] openCheckout() called");
    event.preventDefault();

    // Check if Paddle is loaded
    if (typeof window.Paddle === "undefined") {
      console.error("[PADDLE CONTROLLER] Paddle SDK not loaded!");
      alert(
        "Checkout is currently unavailable. Please disable your ad blocker and refresh the page."
      );
      return;
    }

    console.log("[PADDLE CONTROLLER] Paddle SDK found, building checkout options");

    // Build items array - each item requires priceId and quantity
    const items = [
      {
        priceId: this.priceIdValue,
        quantity: 1,
      },
    ];

    console.log("[PADDLE CONTROLLER] Items:", items);

    // Build checkout options
    const checkoutOptions: PaddleCheckoutOptions = {
      items: items,
      customer: {
        email: this.customerEmailValue,
      },
    };

    // Add customData if present (must be valid JSON with at least one key)
    // Docs: https://developer.paddle.com/build/transactions/custom-data
    if (this.customDataValue && Object.keys(this.customDataValue).length > 0) {
      checkoutOptions.customData = this.customDataValue;
      console.log("[PADDLE CONTROLLER] Custom data added:", this.customDataValue);
    }

    console.log("[PADDLE CONTROLLER] Final checkout options:", checkoutOptions);
    console.log("[PADDLE CONTROLLER] Calling Paddle.Checkout.open()");

    // Open overlay checkout (displayMode: "overlay" is default)
    try {
      window.Paddle.Checkout.open(checkoutOptions);
      console.log("[PADDLE CONTROLLER] Paddle.Checkout.open() called successfully");
    } catch (error) {
      console.error("[PADDLE CONTROLLER] Error opening checkout:", error);
      alert("Error opening checkout: " + error);
    }
  }
}
